/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientNotificationSetting = {
    notification: ClientNotificationSetting.notification;
    enabled: boolean;
};
export namespace ClientNotificationSetting {
    export enum notification {
        CLIENT_APPOINTMENT_REMINDERS = 'client-appointment-reminders',
        CLIENT_BOOKING_SUCCESS = 'client-booking-success',
        CLIENT_BOOKING_REJECTION = 'client-booking-rejection',
        CLIENT_BOOKING_CONFIRMATION = 'client-booking-confirmation',
        CLIENT_BOOKING_CANCELLATION = 'client-booking-cancellation',
        CLIENT_BOOKING_CANCELLED_BY_CLIENT = 'client-booking-cancelled-by-client',
        CLIENT_UNREAD_MESSAGES = 'client-unread-messages',
        CLIENT_SEMINAR_REGISTRATION_CONFIRMATION = 'client-seminar-registration-confirmation',
        CLIENT_SEMINAR_REGISTRATION_BY_THERAPIST = 'client-seminar-registration-by-therapist',
        CLIENT_SEMINAR_SESSION_REMINDER = 'client-seminar-session-reminder',
        CLIENT_SEMINAR_SESSION_CHANGED = 'client-seminar-session-changed',
        CLIENT_SEMINAR_OCCURRENCE_CANCELLATION = 'client-seminar-occurrence-cancellation',
        CLIENT_SEMINAR_REGISTRATION_CANCELLATION = 'client-seminar-registration-cancellation',
        CLIENT_SEMINAR_REGISTRATION_CANCELLED_BY_CLIENT = 'client-seminar-registration-cancelled-by-client',
        CLIENT_SEMINAR_OUTAGE_FEE_APPLIES = 'client-seminar-outage-fee-applies',
    }
}

